import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const conf = async (params: object) => {
  return await GET({ url: Api.conf, params, showError: false })
}
export const usePropSettingTips = async (params: object) => {
  return await GET({ url: Api.usePropSettingTips, params, showError: false })
}
export const set = async (params: object, bizCodeHandler, bizCodes) => {
  return await POST({
    url: Api.set,
    data: params,
    showError: false,
    bizCodeHandler,
    bizCodes
  })
}
